<app-main></app-main>
<app-ticker></app-ticker>
<app-about></app-about>
<app-rules></app-rules>

<app-tariff
  [tariffs]="tariffs"
></app-tariff>
<app-contact-us></app-contact-us>

<app-instagram></app-instagram>
<app-info></app-info>
